import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

// 郵遞區號row
export interface AreaRow {
    zipcode: string;
    area: string;
}

/**
 * @todo Api 回傳值
 */
export interface GetAreaResp extends GeneralResp {
    data: Array<AreaRow>;
}

/**
 * @todo 取鄉鎮市
 */
export const GetArea = (city: string, _showOverlay: boolean = true): Promise<Array<AreaRow>> => {
    const url = RouteUrlList.API_GetArea.path;
    const data = { city: city };

    const config = {
        params: {
            showOverlay: _showOverlay ? ApiClient.paramTypeEnum.true : ApiClient.paramTypeEnum.false,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<GetAreaResp>) => {
        return res.data.data;
    });
};

/**
 * @todo 取得 郵遞區號
 * @param isReturnError
 * @returns
 */
export const GetZipCodeByAreaList = (AreaList: Array<AreaRow>, area: string): string | null => {
    if (!AreaList || !area) {
        return null;
    }
    let zipCode = '';
    AreaList.forEach(function (value, index, array) {
        if (value.zipcode !== null && value.area !== null && value.area == area) {
            zipCode = value.zipcode;
            return;
        }
    });
    return zipCode;
};

export default GetArea;
